// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Finding Form Styles */

.finding-form {
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.finding-form .form-label {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  font-size: 0.95rem;
}

.finding-form .form-control,
.finding-form .form-select {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 10px 12px;
  font-size: 0.95rem;
}

.finding-form .form-control:focus,
.finding-form .form-select:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
}

.finding-form .form-control.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.finding-form .invalid-feedback {
  color: #dc3545;
  font-size: 0.85rem;
  margin-top: 5px;
  display: none;
}

.finding-form .invalid-feedback.d-block {
  display: block;
}

.finding-form textarea {
  resize: vertical;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Severity Options */
.severity-options {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 10px;
}

.severity-radio {
  flex: 1 1;
  min-width: 150px;
}

.severity-radio .form-check-input {
  display: none;
}

.severity-label {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 2px solid #dee2e6;
  border-left: 4px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: white;
  margin: 0;
  font-weight: 500;
}

.severity-radio .form-check-input:checked + .severity-label {
  background-color: #f0f7ff;
  border-color: #0d6efd;
  border-left-color: #0d6efd;
}

.severity-label:hover {
  border-color: #0d6efd;
}

.severity-badge {
  font-size: 1.2rem;
  min-width: 30px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.severity-text {
  font-weight: 500;
  color: #2c3e50;
}

/* Character counter */
.float-end.text-muted {
  font-size: 0.85rem;
}

/* Form submit button */
.finding-form .btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 4px;
}

.finding-form .btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .severity-options {
    flex-direction: column;
  }

  .severity-radio {
    min-width: 100%;
  }

  .finding-form {
    padding: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AuditFindings/FindingForm.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Finding Form Styles */\n\n.finding-form {\n  background-color: white;\n  padding: 20px;\n  border-radius: 4px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.finding-form .form-label {\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 8px;\n  font-size: 0.95rem;\n}\n\n.finding-form .form-control,\n.finding-form .form-select {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 10px 12px;\n  font-size: 0.95rem;\n}\n\n.finding-form .form-control:focus,\n.finding-form .form-select:focus {\n  border-color: #0d6efd;\n  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n}\n\n.finding-form .form-control.is-invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.finding-form .invalid-feedback {\n  color: #dc3545;\n  font-size: 0.85rem;\n  margin-top: 5px;\n  display: none;\n}\n\n.finding-form .invalid-feedback.d-block {\n  display: block;\n}\n\n.finding-form textarea {\n  resize: vertical;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n/* Severity Options */\n.severity-options {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n\n.severity-radio {\n  flex: 1;\n  min-width: 150px;\n}\n\n.severity-radio .form-check-input {\n  display: none;\n}\n\n.severity-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 2px solid #dee2e6;\n  border-left: 4px solid #dee2e6;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background-color: white;\n  margin: 0;\n  font-weight: 500;\n}\n\n.severity-radio .form-check-input:checked + .severity-label {\n  background-color: #f0f7ff;\n  border-color: #0d6efd;\n  border-left-color: #0d6efd;\n}\n\n.severity-label:hover {\n  border-color: #0d6efd;\n}\n\n.severity-badge {\n  font-size: 1.2rem;\n  min-width: 30px;\n  text-align: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.severity-text {\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n/* Character counter */\n.float-end.text-muted {\n  font-size: 0.85rem;\n}\n\n/* Form submit button */\n.finding-form .btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 4px;\n}\n\n.finding-form .btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .severity-options {\n    flex-direction: column;\n  }\n\n  .severity-radio {\n    min-width: 100%;\n  }\n\n  .finding-form {\n    padding: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
